import { neutral } from '@bloomfieldrobotics/canopy';
import { Paper, PaperProps, styled } from '@mui/material';

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  border: '0.5px solid',
  borderColor: neutral[800],
}));

export const MenuPaper = (props: PaperProps) => {
  return <StyledPaper {...props} elevation={0} />;
};
